var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSegments24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.004,
    viewBox: "0 0 18 17.004",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_segment",
    d: "M456.467,1031.527l2.69-8.007a7.806,7.806,0,1,0,5.448,8.007Zm4.77-9.768-2.757,8.333h8.612A9.1,9.1,0,0,0,461.238,1021.759Z",
    transform: "translate(-449.093 -1021.759)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSegments24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_segments24x24.88b46b3d258ca3d494d686df371b3178.svg";